
export function modalInit() {
    /**
     * Modals
     */
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="modal"]'));
    tooltipTriggerList.map(async (tooltipTriggerEl) => {
        const modalId = tooltipTriggerEl.dataset.target.replace('#', '')
        const modalElement = document.getElementById(modalId)
        if (modalElement) {
            let {default: Modal} = await import('bootstrap/js/dist/modal');
            const modal = new Modal(modalElement, {});
            tooltipTriggerEl.addEventListener('click', async () => {
                modal.show()
                const closeEl = modalElement.querySelector('[data-dismiss="modal"')
                if (closeEl) {
                    closeEl.addEventListener('click', () => {
                        setTimeout(() => document.querySelectorAll('.modal-backdrop').forEach(e => e.remove()), 300)
                        modal.hide()
                    })
                }
            })
        } else {
            console.error(`ModalInit: not exist modal element with id ${modalId}`)
        }
    });
}
